import { SVGLike } from "../../../../public/SVG/SVGLike";
import { SVGDeslike } from "../../../../public/SVG/SVGDeslike";

import { SVGRemoveFiltro } from "../../components/SVG/SVGRemoveFiltro";
import styles from "./stylesCard.module.css"
import { useEffect } from "react";

export function CardStatus(props) {

    const vQuantidade = parseInt(props.Registros
        .filter(e => e?.Status === props.Status)
        .length, 10).toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(',', '.')

    const vPorcentagem = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(((parseFloat(
        props.Registros
            .filter(e => e?.Status === props.Status)
            .length
    ) / parseInt(props.Registros.length, 10)) * 100).toFixed(2))

    const totalDoStatus = props.Registros?.filter(p => p.Status === props.Status)?.reduce(getTotalDoStatus, 0)
    function getTotalDoStatus(total, item) {
        return parseFloat(total) + (parseFloat(item.Total) || 0.00)
    }

    const totalGeral = props.Registros?.reduce(getTotalGeral, 0) || 0
    function getTotalGeral(total, item) {
        return parseFloat(total) + (parseFloat(item.Total) || 0.00)
    }

    const vValorUnitario = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(totalDoStatus.toFixed(2))

    const vPercUnitario = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(((totalDoStatus / totalGeral) * 100).toFixed(2))

    const QtdDoStatus = props.Registros
        .filter(e => e?.Status === props.Status)
        .length

    const tMedioDoStatus = (totalDoStatus.toFixed(2) / QtdDoStatus) || 0.00

    const vTicketMedio = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(tMedioDoStatus.toFixed(2))

    const showIconFiltered = props.statusAtual.filter(e => e.label === props.Status).length > 0 ? true : false

    const renderButtonLike = () => {
        return (
            <div style={{
                opacity: showIconFiltered && props.likeMode ? 0.4 : 1,
                pointerEvents: showIconFiltered && props.likeMode ? 'none' : 'auto'
            }} >
                {props.showButtonLike ?
                    props.likeMode ?
                        <SVGLike onClick={() => {
                            props.setLikeMode(false)
                            props.setFilter(true)

                        }} color='green' style={{ cursor: 'pointer' }} />
                        :
                        <SVGDeslike onClick={() => {
                            props.setLikeMode(true)
                            props.setFilter(false)
                        }} color='red' style={{ cursor: 'pointer' }} />
                    :
                    null
                }
            </div>
        )
    }


    useEffect(() => {

    }, [])

    return (
        <div
            style={props.estyloProps || null}
            className={` ${styles.card} bg-white-100 min-w-[30%] relative rounded-xl  pb-5 shadow-lg flex flex-row
            ${props.isPrincipal ? ' ' : 'h-full '}
            `}
        >
            <div
                onClick={() => {
                    showIconFiltered ?
                        props.clearFiltroStatus(props.Status)
                        :
                        props.setStatusFiltro(props.Status)
                }}
                className={` ${showIconFiltered ? 'animate-pulse' : ''}
                    flex justify-center items-center bg-gradient-to-b ${props.gradientColor} shadow-lg  
                    ${props.isFiltered ? 'cursor-pointer transform transition duration-500 hover:scale-110' : ''}
                    ${props.isPrincipal ? ` ${styles.circleCard} border-white-200 border-[0.3rem] ml-[-1rem] h-[7rem] w-[14rem] rounded-[50%] mt-[-2.5rem]`
                        : 'rounded-xl h-[4.5rem] w-[17rem] p-6 mt-[-1.25rem] ml-2'}
                    
                    `}
                style={{ background: props.isPrincipal && '#5081da' }}
            >
                <p className={`${styles.value} text-white-200 font-bold ${props.isPrincipal ? 'text-3xl font-bold' : 'text-[1.2rem]'} `}>
                    {vQuantidade}
                </p>


                <p className={`${styles.porcentagem}  mb-1 absolute bottom-0 right-0 mr-3 text-white-200  ${props.colorText}`}>
                    {vPorcentagem !== 'NaN' ? vPorcentagem : '0,00'} %
                </p>


                {showIconFiltered
                    ? <div
                        className="IconRemoveFilter"
                    >
                        <SVGRemoveFiltro color={props.Status === 'PERDIDO' ? 'white' : 'red'} />
                    </div>
                    : null
                }
            </div>
            <div className={`mt-3 flex flex-col w-full ml-2 mr-4 `}>
                <div className="flex flex-row items-center justify-between " >
                    <p className={` ${styles.title} text-lg text-slate-500 ${props.isPrincipal ? 'font-bold text-2xl' : ''}`}>
                        {props?.Status?.charAt(0)?.toUpperCase() + props.Status?.slice(1)?.toLowerCase()}
                    </p>
                    {renderButtonLike()}
                </div>

                <div className={`border border-slate-200 shadow-lg mb-2`}>

                </div>

                <div className={styles.containerValorUnitario} >
                    <p className={styles.valorUnitario} >R$ {vValorUnitario || `0,00`}</p>
                    <p className={styles.perc} > ({vPercUnitario !== 'NaN' ? vPercUnitario : '0,00'}%)</p>
                </div>

                <div className={styles.containerValorUnitario} >
                    <p className={styles.valorUnitario} >R$ {vTicketMedio || '0,00'}</p>
                    <p className={styles.perc} > (Ticket médio)</p>
                </div>

                <div style={{
                    display: props?.ExibirServicoDetalhes ? 'flex' : 'none'
                }} className={styles.containerValorUnitario}
                ><p className={styles.valorUnitario} >{props?.ExibirServicoDetalhes
                    ?.filter(e => e.Status === props.Status)
                    ?.length}</p>
                    <p className={styles.perc} > (Serviços)</p>

                </div>
            </div>
        </div>
    )
}
